<template>
</template>
<script>
export default {
    name: 'facture-customer-dashboard'
}
</script>


// WEBPACK FOOTER //
// src/views/website/customer/facture.vue